import React from 'react';
import { Navigate } from 'react-router-dom';

import MainView from './MainView';
import NotFoundView from './errors/NotFoundView';

const routes = (content, queryParams) => {
	let queryStr = queryParams.toString();
	if (queryStr) queryStr = '?' + queryStr;

	return [
		{
			path: '/',
			element:
				<MainView
					content={content}
					editMode={queryParams.get('editMode')}
				/>
		},
		{
			path: '*',
			element: <NotFoundView />
		},
	];
}

export default routes;
